// Wrap everything in an IIFE (Immediately Invoked Function Expression) to avoid global scope pollution
(function () {
  const CUSTOMER_NAMES = ['Florian', 'Max', 'Vanessa', 'Ana', 'Jonas', 'Peter', 'Julia', 'Paul', 'Hector', 'Luis'];

  function calculateCustomerCount(startDate, dailyIncrease) {
    const start = new Date(startDate);
    const today = new Date();
    const daysDiff = Math.floor((today - start) / (1000 * 60 * 60 * 24));

    // If we're before the start date, return the initial count
    if (daysDiff < 0) {
      return {
        count: 40564,
      };
    }

    // Calculate the increase based on days passed
    const increase = daysDiff * dailyIncrease;
    return {
      count: 40564 + increase,
    };
  }

  function getRandomName() {
    // Simple random selection from the array
    const randomIndex = Math.floor(Math.random() * CUSTOMER_NAMES.length);
    return CUSTOMER_NAMES[randomIndex];
  }

  // Only define the custom element if it hasn't been defined yet
  if (!customElements.get('social-proof-counter')) {
    class SocialProofCounter extends HTMLElement {
      constructor() {
        super();
        this.startDate = this.getAttribute('data-start-date') || '2025-07-15';
        this.dailyIncrease = parseInt(this.getAttribute('data-daily-increase')) || 49;
        this.updateCounter();
      }

      updateCounter() {
        const { count } = calculateCustomerCount(this.startDate, this.dailyIncrease);
        const formattedCount = new Intl.NumberFormat('de-DE').format(count);
        const randomName = getRandomName();

        // Get the text content and replace both the name and number
        const text = this.textContent;
        const updatedText = text
          .replace(/\b(Sabine|Florian|Max|Vanessa|Ana|Jonas|Peter|Julia|Paul|Hector|Luis)\b/, randomName)
          .replace(/\d+(?:[.,]\d+)*/, formattedCount);
        this.textContent = updatedText;
      }
    }

    customElements.define('social-proof-counter', SocialProofCounter);
  }
})();
